export class ModifiedDataStorage {
  addedDatas: any[] = [];
  modifiedDatas: any[] = [];
  deletedDatas: any[] = [];

  clear(): void {
    this.addedDatas = [];
    this.modifiedDatas = [];
    this.deletedDatas = [];
  }
}
